import { all, call, fork, put, select, takeLatest } from "redux-saga/effects";
import dayjs from "dayjs";

import setAppConfigs from "@lib/setAppConfigs";
import { actions as authActions } from "@reducers/authReducer";
import { getDropDownOptions, getUserDetails } from "@services/api";
import { actions as vacationActions } from "@reducers/vacationReducer";
import { actions as supportActions } from "../reducers/supportReducer";
import {
  GET_USER_DETAILS_BY_TOKEN_REQUEST,
  GET_USER_DETAILS_BY_TOKEN_SUCCESS,
  SET_CLDROPDOWNOPTIONS,
} from "../reducers/actionTypes";
import {
  handleDeepLinkNavigation,
  setDeepLinkParams,
} from "../actions/deepLink.actions";
import { setSentryCrashlytics } from "./configSaga";

const Today = dayjs().format("YYYY-MM-DD");

function* getDetailsOfUser(action) {
  const {
    payload: {
      cache = false,
      doNotShowSuspensionModal = false,
      showVacationModal = false,
      userData,
    } = {},
  } = action;
  try {
    let meResponse;
    yield put(authActions.resetFetchMeCompleted());
    if (userData?.meResponse) {
      meResponse = userData.meResponse;
    } else {
      const { data } = yield call(getUserDetails, cache);
      meResponse = data;
    }

    const {
      data: { supportTicket, clDropDownOptions },
    } = yield call(getDropDownOptions);

    const earlyJourney = yield select(
      ({ configReducer }) => configReducer?.earlyJourney,
    );

    const payload = {
      ...meResponse,
      supportTicket,
      clDropDownOptions,
      earlyJourney,
    };

    yield put({
      type: GET_USER_DETAILS_BY_TOKEN_SUCCESS,
      payload,
    });

    yield fork(setSentryCrashlytics, meResponse);

    const is_suspended =
      userData?.is_suspended || userData?.leader_state === "LEADER_SUSPENDED";

    if (!doNotShowSuspensionModal) {
      yield put(authActions.showSuspensionModal(is_suspended || false));
    }

    if (is_suspended) yield put(supportActions.getSupportConfigs());

    const deepLink = yield select(({ deepLink }) => deepLink.deepLinkParams);
    if (deepLink && Object.keys(deepLink).length > 0) {
      yield put(handleDeepLinkNavigation(deepLink));
      yield put(setDeepLinkParams(null));
    }
    yield put(authActions.setFetchMeCompleted());
  } catch (error) {
    console.log(error.response);
  }
  yield put({ type: "FETCH_ME_COMPLETED" });
}

export default function* root() {
  yield all([takeLatest(GET_USER_DETAILS_BY_TOKEN_REQUEST, getDetailsOfUser)]);
}
